import React, { Component } from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  TextField,
  Select,
  MenuItem,
} from "@material-ui/core";
import { PostData } from "../../api/service";

export default class AddButton extends Component {
  state = {
    open: false,
    title: "",
    content_type: "section",
    year: "",
  };

  handleSave = () => {
    const parent_id = this.props.parentId || null;

    const payload = {
      title: this.state.title,
      content_type: this.state.content_type,
      parent_id: parent_id,
      year: this.state.year,
    };

    PostData(`/${this.props.apikey}/library/add`, payload).then((resp) => {
      alert("Added Successfully!");
      this.setState({ open: false });
      this.props.refresh();
    });
  };

  render() {
    return (
      <div>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => this.setState({ open: true })}
          style={
            this.props.floating === false
              ? { width: "100%" }
              : { position: "fixed", bottom: 20, right: 20 }
          }
        >
          + Add
        </Button>

        <Dialog
          open={this.state.open}
          onClose={() => this.setState({ open: false })}
        >
          <DialogTitle>Add New Item</DialogTitle>
          <DialogContent>
            <TextField
              label="Title"
              fullWidth
              onChange={(e) => this.setState({ title: e.target.value })}
              style={{ marginTop: 10 }}
            />

            <Select
              fullWidth
              value={this.state.content_type}
              onChange={(e) => this.setState({ content_type: e.target.value })}
              style={{ marginTop: 15 }}
            >
              <MenuItem value="section">Section</MenuItem>
              <MenuItem value="text">Text Page</MenuItem>
              <MenuItem value="file">File Upload</MenuItem>
            </Select>

            <TextField
              label="Year (Optional)"
              fullWidth
              onChange={(e) => this.setState({ year: e.target.value })}
              style={{ marginTop: 10 }}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={() => this.setState({ open: false })}>
              Cancel
            </Button>
            <Button onClick={this.handleSave} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/AdminLibrary/AddButton.js